import { render, staticRenderFns } from "./roleView.vue?vue&type=template&id=b99106c4"
import script from "./roleView.vue?vue&type=script&lang=js"
export * from "./roleView.vue?vue&type=script&lang=js"
import style0 from "./roleView.vue?vue&type=style&index=0&id=b99106c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports